<template>
    <div>
        <b-modal
            :id="modalId"
            @hidden="onModalHidden()"
            modal-class="modal-point-step"
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="modal-base">
                <div class="modal-base-head">
                    <div class="header-login">
                        <div class="text">
                            <p>{{lbl.static.point_stepModal.title}}</p>
                        </div>
                    </div>
        
                    <div class="modal-base-close" @click="hide()">
                        <img src="@/assets/icon/otp_icon_close@3x.png" />
                    </div>
                </div>
                <div class="modal-base-body">
                    <div class="special-text">
                        <div class="text-description text-center ">
                            <div class="wrap-text">
                                <div class="text-img">
                                    <div class="text-no-one">
                                        {{lbl.static.point_stepModal.stepOne.no}}
                                        <span>
                                            {{lbl.static.point_stepModal.stepOne.textPink}}
                                        </span>
                                        {{lbl.static.point_stepModal.stepOne.textGray}}
                                        <img class="logo-naos" src="@/assets/pointStep/logoNaos @2x.png">
                                        {{lbl.static.point_stepModal.stepOne.textGray2}}
                                    </div>
                                    <!-- <div class="logo-naos">
                                        <img  src="@/assets/pointStep/logoNaos @2x.png">
                                    </div> -->
                                </div>
                            </div>
                            <div class="img-flex">
                                <div class="img-bottle">
                                    <img src="@/assets/pointStep/img-bottle@2x.png">
                                </div>
                                <div class="img-box">
                                    <img src="@/assets/pointStep/img-box@2x.png">
                                </div>
                            </div>
                            <div class="wrap-text">
                                {{lbl.static.point_stepModal.stepTwo.no}}
                                <span>
                                    {{lbl.static.point_stepModal.stepTwo.text_qr_old_pink}}
                                </span>
                                {{lbl.static.point_stepModal.stepTwo.text_qr_old_gray}}
                                <span>
                                    {{lbl.static.point_stepModal.stepTwo.text_qr_new_pink}}
                                </span>
                                {{lbl.static.point_stepModal.stepTwo.text_qr_new_gray}}
                            </div>
                            <div class="img-flex-qr">
                                <div class="img-qr-old">
                                    <img src="@/assets/pointStep/img-old-qr@2x.png">
                                </div>
                                <div class="img-qr-new">
                                    <img src="@/assets/pointStep/img-new-qr@2x.png">
                                </div>
                            </div>
                            <div class="margin-text">
                                <div class="wrap-text">
                                    {{lbl.static.point_stepModal.stepThree.no}}
                                    {{lbl.static.point_stepModal.stepThree.textGray}}
                                <span>
                                    {{lbl.static.point_stepModal.stepThree.textPink}}
                                </span>
                                </div>
                            </div>
                            <div class="margin-text">
                            <div class="wrap-text">
                                {{lbl.static.point_stepModal.stepFour.no}}
                                <span>
                                    {{lbl.static.point_stepModal.stepFour.textPink}}
                                </span>
                                {{lbl.static.point_stepModal.stepFour.textGray}}
                            </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import Locale from "@/helper/locale/locale.js";
/**
 * @property {PointCollectionStepModal} controller (required)../Controller/PointCollectionStepModalController.js
 * @property {String} modalId (reqquired)
 */
import LocaleMixin from "@/mixin/LocaleMixin.js";
export default {
    name: "PointCollectionStepModal",
    props: {
        controller: Object,
        modalId: String
    },
    components: {},
    mixins: [LocaleMixin],
    data: function() {
        return {
            title: "",
            message: "",
            btnOk: "",
            tag: "",
            busModal: null,
            lbl: Locale.getLbl(),
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on("show", this.show);
        this.busModal.$on("hide", this.hide);
    },
    methods: {
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function() {
            this.hide();
            this.controller.sendCallbackOk({ tag: this.tag });
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.tag = config.tag;
            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/baseImage.scss";
@import "@/style/base/baseText.scss";
.text-description {
    .wrap-text {
        text-align: left;
        font-family: 'Regular';
    }
}
</style>
<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";
@import "@/style/modal.scss";
@import "../style/PointCollectionStepModal.scss";
</style>
